import { Injectable } from '@angular/core';

import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { MatchExclusionsBackend } from '@libs/src/match-exclusions/match-exclusions.backend';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import {
  getMatchExclusionsUpdate,
  getMembership,
} from '@main-client/src/app/account/account.helpers';
import { MatchSelections } from '@main-client/src/app/group-intro-selections-form/match-selections';

@Injectable({ providedIn: 'root' })
export class GroupIntroSelectionsFormService {
  constructor(
    private groupsBackend: GroupsBackend,
    private matchExclusionsBackend: MatchExclusionsBackend,
  ) {}

  saveIntroSelections(
    group: Group,
    user: Account,
    selections: MatchSelections,
  ) {
    const membership =
      getMembership(user.groups, group._id) ||
      getMembership(user.pending_groups, group._id);
    const update = getMatchExclusionsUpdate(
      membership.match_exclusions,
      selections,
    );
    return this.matchExclusionsBackend.v3.putAccountMatchExclusions(
      group._id,
      update,
    );
  }

  saveMatchExclusionsForAccount(
    group: Group,
    account: Account,
    selections: MatchSelections,
  ) {
    const membership = getMembership(account.groups, group._id);
    const update = getMatchExclusionsUpdate(
      membership.match_exclusions,
      selections,
    );
    return this.groupsBackend.putAccountsGroups(group, account, update);
  }
}
